import { SET_VIEW } from '../actionConstants';
import defaultState from './navigationDefaultState';

export default (state = defaultState, action: any) => {
  switch (action.type) {
    case SET_VIEW:
      return {
        ...state,
        currentView: action.payload.view,
        history: state.currentView ? [state.currentView, ...state.history] : [],
      };

    default:
      return state;
  }
};
